import type { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import {
  faBullseye,
  faCalendarCirclePlus,
  faChartLineUp,
  faClock,
  faDollarSign,
  faImage,
  faLaptopMobile,
} from '@fortawesome/pro-regular-svg-icons';
import { t } from 'i18next';

import { ERecommendationType } from '@feathr/blackbox';

interface IRecommendationContent {
  /** The action text of the recommendation */
  action: string;
  /** The icon of the recommendation */
  icon: IconDefinition;
}

/**
 * Returns the content of a recommendation based on the type of recommendation
 * @param type
 * @returns the content of a recommendation: action text and icon
 */
export const getRecommendationContent = (type: ERecommendationType): IRecommendationContent => {
  const recommendations = {
    [ERecommendationType.Budget]: {
      action: t('Increase budget'),
      icon: faDollarSign,
    },
    [ERecommendationType.BudgetDuration]: {
      action: t('Update campaign'),
      icon: faCalendarCirclePlus,
    },
    [ERecommendationType.ExtendCampaign]: {
      action: t('Extend campaign'),
      icon: faCalendarCirclePlus,
    },
    [ERecommendationType.UpdateCreatives]: {
      action: t('Update creatives'),
      icon: faImage,
    },
    [ERecommendationType.IncreaseBaseBid]: {
      action: t('Increase base bid'),
      icon: faChartLineUp,
    },
    [ERecommendationType.IncreaseFrequencyCap]: {
      action: t('Increase frequency cap'),
      icon: faClock,
    },
    [ERecommendationType.EnableOmnitargeting]: {
      action: t('Enable omnitargeting'),
      icon: faLaptopMobile,
    },
    [ERecommendationType.MissingGoal]: {
      action: t('Add a goal'),
      icon: faBullseye,
    },
  };

  return recommendations[type];
};
